import React from 'react'
import { ICONS } from '@Const/common'
import { SearchResultPartyDetails } from '@Entities/party-details'
import Pluralize from 'pluralize'
import numberOrZero from '@App/helpers/number-or-zero'

interface CowriterSearchResultRowDataProps {
    data: SearchResultPartyDetails[]
    onSelectWriter: (writer: SearchResultPartyDetails) => void
}

const CowriterSearchResultRowData = (props: CowriterSearchResultRowDataProps) => {
    const { data, onSelectWriter } = props
    return (
        <>
            {data?.map((cowriter) => (
                <tr key={cowriter.ipId}>
                    <td>
                        <div className="cowriter-data">
                            <div className="cowriter-data-left">
                                <div className="cowriter-name-titles">
                                    <span className="cowriter-name">{cowriter.name}</span>
                                    <div className="cowriter-ipi">
                                        <span>IPI:</span> {cowriter.ipiNumber}
                                    </div>
                                </div>
                            </div>
                            <div className="cowriter-data-right">
                                <button
                                    className="songs-count-section"
                                    onClick={() => !!cowriter.worksCount && onSelectWriter(cowriter)}
                                >
                                    <span className="songs-count-left-section">
                                        <span className="songs-count-value">{cowriter.worksCount}</span>
                                        <span className="songs-count-bottom-section">
                                            {Pluralize('song', numberOrZero(cowriter.worksCount))}
                                        </span>
                                    </span>
                                    <img src={ICONS.chevron_right} />
                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
            ))}
        </>
    )
}
export default CowriterSearchResultRowData
